import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ScrollText, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CIRCULAR_FILE_URL = 'https://customer-assets.emergentagent.com/job_97725229-7456-4625-a973-72749269d95f/artifacts/x5x5hs4a_HR%20DEPARTMENT%20CIRCULAR.docx';

const HR_INDEX = [
  { sr: 1, title: 'HR STANDARD OPERATING PROCEDURE', items: [] },
  { sr: 2, title: 'REPORTS', items: [
    'PRESENTY','DAILY WORK SCHEDULE','MONTH WORK SCHEDULE','ALL PROJECT WORK',
    'PERFORMANCE MEASURMENT','SKILLS OF STAFF','CTC CALCULATION','SALARY CALCULATION',
    'STAFF SETUP','WEEKLY & YEARLY LEAVE PLANNING','HR LETTERS','FACILITY TO STAFF',
    'ALL PROJECT VISITER LIST','SALARY STATEMENT'
  ]},
  { sr: 3, title: 'CIRCULAR', items: [
    'UNPLANE LEAVE POLICY','LATE CHARGES','HALF DAY CONDITION','WORK REPORT',
    'STAFF MEETING','PERFORMANCE MANAGEMENT','STRENGTH OF STAFF','DRESS CODE',
    'PERSONALITY','OFFICE SETUP','STAFF TRAINING','EXPENSES VOUCHER',
    'STAFF POLICY','STAFF SERVICE','USE OF MOBILE IN OFFICE','WEEKLY OFF',
    'YEARLY LEAVE PLANNING','PROMOTION','DIWALI BONUS'
  ]},
];

const POLICIES = [
  { title: 'TERMS AND CONDITIONS FOR LEAVE', body: "Staff will be given urgent leave in case of illness — but the doctor's certificate should be submitted. For death in the family (father, mother, brother, sister, cousin, aunt, uncle), urgent leave will be given with relevant proof. Inform 4 days in advance for any planned leave with signed application form. Leave taken without 4-day notice will result in DOUBLE salary deduction per day." },
  { title: 'TERMS AND CONDITIONS FOR LATE MARK', body: 'If staff comes 15 minutes late, a late mark is attracted. The company allows up to 3 late marks; from the 4th onwards, 1 day salary will be deducted per late mark.' },
  { title: 'TERMS AND CONDITIONS FOR HALF DAY', body: 'For half day, staff must fill the application form and obtain HR Department signature. Half-day timing is after 2:00 PM.' },
  { title: 'WORK REPORTING', body: 'Daily work — report to department head every day. Weekly work — report every Saturday. Monthly work — report at the end of the month.' },
  { title: 'STAFF MEETING', body: 'Daily startup: 10:05 – 10:15 AM. Weekly meeting: every Saturday. Monthly meeting: 2nd of every month.' },
];

const PERFORMANCE_LIST = [
  'PRESENTATION','DAILY SCHEDULE','DAILY WORK','LEAVE PLANNING','REPORTING','ISSUES HANDLING',
  'CTC','FINANCIAL MANAGEMENT','TEAM MANAGEMENT','DRESS CODE','ADVANCE DEDUCTION','SKILL',
  'KNOWLEDGE','BEHAVIOR','HABITS','GOSSIPING','CREDITOR','PRIVACY','PRAISE','HARD WORKING',
  'LEADERSHIP','NATURE','HEALTH','POSITIVE THINKING'
];

const PROMOTION_TABLE = [
  { sr: 1, particular: 'DEPARTMENT RESPONSIBILITY + DKW SELENDER + CTC + EXTRA ORDINARY', pct: '30%', color: '#16a34a' },
  { sr: 2, particular: 'DEPARTMENT RESPONSIBILITY + DKW SELENDER + CTC', pct: '20%', color: '#22c55e' },
  { sr: 3, particular: 'DEPARTMENT RESPONSIBILITY + DKW SELENDER', pct: '10%', color: '#84cc16' },
  { sr: 4, particular: 'ONLY PRESENTY', pct: '0%', color: '#a3a3a3' },
  { sr: 5, particular: 'GOSSIPING + POLITICS + WORK AVOID', pct: '-100%', color: '#dc2626' },
];

const DKW_TABLE = [
  { age: 18, year: 2023, salary: 5000, particular: 'Presenty' },
  { age: 19, year: 2024, salary: 10000, particular: 'Presenty + Department Skill + Computer Knowledge' },
  { age: 20, year: 2025, salary: 15000, particular: 'Presenty + Department Skill + Computer Knowledge + Two-Wheeler + Car Driving' },
  { age: 21, year: 2026, salary: 25000, particular: 'Presenty + Department Skill + Computer Knowledge + Two-Wheeler + Car Driving + English' },
  { age: 22, year: 2027, salary: 40000, particular: 'All above + Knowledge + Responsibility + Decision + Issues Handling + Department Handling + 100% Responsibility' },
  { age: 23, year: 2028, salary: 60000, particular: 'All above + Knowledge + Responsibility + Decision + Issues Handling + Department Handling + 100% Responsibility' },
  { age: 24, year: 2029, salary: 80000, particular: 'All above + Knowledge + Responsibility + Decision + Issues Handling + Department Handling + 100% Responsibility' },
  { age: 25, year: 2030, salary: 100000, particular: 'All above + Knowledge + Responsibility + Decision + Issues Handling + Department Handling + 100% Responsibility' },
];

const HOLIDAYS = [
  { sr: 1, date: '14-01-2025', day: 'TUESDAY', type: 'HALF DAY', name: 'MAKAR SANKRANTI', remark: '' },
  { sr: 2, date: '26-01-2026', day: 'SUNDAY', type: 'FULL DAY', name: 'REPUBLIC DAY', remark: 'NATIONAL HOLIDAY' },
  { sr: 3, date: '14-03-2025', day: 'FRIDAY', type: 'FULL DAY', name: 'HOLI', remark: '' },
  { sr: 4, date: '30-03-2025', day: 'SUNDAY', type: 'FULL DAY', name: 'GUDI PADWA', remark: '' },
  { sr: 5, date: '01-05-2025', day: 'THURSDAY', type: 'FULL DAY', name: 'LABOUR DAY', remark: '' },
  { sr: 6, date: '09-08-2025', day: 'SATURDAY', type: 'FULL DAY', name: 'RAKSHABANDHAN', remark: '' },
  { sr: 7, date: '15-08-2025', day: 'FRIDAY', type: 'FULL DAY', name: 'INDEPENDENCE DAY', remark: 'NATIONAL HOLIDAY' },
  { sr: 8, date: '27-08-2025', day: 'WEDNESDAY', type: 'HALF DAY', name: 'GANESH CHATURTHI', remark: '' },
  { sr: 9, date: '06-09-2025', day: 'SATURDAY', type: 'HALF DAY', name: 'ANANT CHATURDASHI', remark: '' },
  { sr: 10, date: '02-10-2025', day: 'THURSDAY', type: 'FULL DAY', name: 'DUSSERA & GANDHI JAYANTHI', remark: 'NATIONAL HOLIDAY' },
  { sr: 11, date: '21-10-2025', day: 'TUESDAY', type: 'FULL DAY', name: 'LAKSHMI PUJA', remark: 'STAFF ALTERNATIVE LEAVE' },
  { sr: 12, date: '22-10-2025', day: 'WEDNESDAY', type: 'FULL DAY', name: 'DIWALI PADWA', remark: 'STAFF ALTERNATIVE LEAVE' },
  { sr: 13, date: '23-10-2025', day: 'THURSDAY', type: 'FULL DAY', name: 'BHAUBEEJ/BHAIDUJ', remark: 'STAFF ALTERNATIVE LEAVE' },
];

const Section = ({ title, children, accent = '#1e3a8a' }) => (
  <div className="mb-6">
    <h3 className="text-sm font-bold text-white px-3 py-2 rounded-t" style={{ backgroundColor: accent }}>{title}</h3>
    <div className="bg-white border border-stone-200 rounded-b p-4 text-sm text-stone-700 leading-relaxed">{children}</div>
  </div>
);

export default function CircularTab() {
  return (
    <div className="space-y-4" data-testid="hr-circular-tab">
      <div className="flex items-center justify-between bg-amber-700 text-white px-4 py-3 rounded-lg">
        <div className="flex items-center gap-3">
          <ScrollText className="w-5 h-5" />
          <div>
            <h2 className="text-lg font-bold">HR DEPARTMENT — Circular & Policies</h2>
            <p className="text-xs text-amber-100">Official policies, terms &amp; conditions, and updated holiday list</p>
          </div>
        </div>
        <a href={CIRCULAR_FILE_URL} target="_blank" rel="noopener noreferrer" download>
          <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="circular-download-btn">
            <Download className="w-4 h-4 mr-1.5" /> Download .docx
          </Button>
        </a>
      </div>

      {/* HR INDEX TABLE */}
      <Card>
        <CardContent className="p-4">
          <Section title="HR INDEX">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-blue-100">
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-12">SR.</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left">NAME OF REPORT</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-32">CONTACT</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-24">STATUS</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-24">REMARK</th>
                </tr>
              </thead>
              <tbody>
                {HR_INDEX.map((g) => (
                  <React.Fragment key={g.sr}>
                    <tr className="bg-amber-50 font-bold">
                      <td className="border border-stone-300 px-2 py-1.5">{g.sr}</td>
                      <td className="border border-stone-300 px-2 py-1.5">{g.title}</td>
                      <td className="border border-stone-300 px-2 py-1.5">SAHIL</td>
                      <td className="border border-stone-300 px-2 py-1.5"><span className="bg-green-600 text-white px-2 py-0.5 rounded text-[10px]">DONE</span></td>
                      <td className="border border-stone-300 px-2 py-1.5">OK</td>
                    </tr>
                    {g.items.map((it, i) => (
                      <tr key={i} className="hover:bg-stone-50">
                        <td className="border border-stone-300 px-2 py-1.5"></td>
                        <td className="border border-stone-300 px-2 py-1.5 pl-6">{i+1}. {it}</td>
                        <td className="border border-stone-300 px-2 py-1.5">SAHIL</td>
                        <td className="border border-stone-300 px-2 py-1.5"><span className="bg-green-600 text-white px-2 py-0.5 rounded text-[10px]">DONE</span></td>
                        <td className="border border-stone-300 px-2 py-1.5">OK</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </Section>

          {/* POLICIES */}
          {POLICIES.map((p, i) => (
            <Section key={i} title={p.title} accent="#7c2d12">
              <p>{p.body}</p>
            </Section>
          ))}

          {/* PERFORMANCE LIST */}
          <Section title="PERFORMANCE MEASUREMENT — 24 Parameters" accent="#0f766e">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5">
              {PERFORMANCE_LIST.map((p, i) => (
                <div key={i} className="flex items-center gap-2 bg-teal-50 px-2 py-1 rounded text-xs">
                  <span className="w-5 h-5 rounded-full bg-teal-600 text-white text-[10px] font-bold flex items-center justify-center">{i+1}</span>
                  {p}
                </div>
              ))}
            </div>
          </Section>

          {/* MISC POLICIES */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Section title="DRESS CODE OF STAFF" accent="#0369a1">
              <p>Company provides 2 shirts, 1 pant, 1 blazer to new staff. Cost is split 50/50 between staff and company. Refunded to staff after completion of 3 months. Friday is Casual Day.</p>
            </Section>
            <Section title="PERSONALITY (FORMAL DRESS)" accent="#0369a1">
              <p>Sky-blue shirt · Black pants · Black blazer · Black belt · Black socks · Black shoes</p>
            </Section>
            <Section title="OFFICIAL SETUP" accent="#0369a1">
              <p>Diary · File · Pen drive · Laptop · Chair · Stationery pouch</p>
            </Section>
            <Section title="TRAINING PERIOD" accent="#0369a1">
              <p>1 month training: DBK group orientation, company &amp; department rights, designation, penalty, voucher &amp; expenses.</p>
            </Section>
            <Section title="STAFF POLICY" accent="#0369a1">
              <p>Medical policy taken by company; cost shared 50/50 between staff and company.</p>
            </Section>
            <Section title="WEEKLY OFF" accent="#0369a1">
              <p>No weekly leave on Saturdays/Sundays. Same-department staff cannot take leave together; backup must be suggested.</p>
            </Section>
          </div>

          {/* SERVICE TO STAFF */}
          <Section title="SERVICE TO STAFF IN OFFICE" accent="#9333ea">
            <ul className="list-disc pl-6 space-y-1">
              <li>Tea time: 11:00 AM and 4:00 PM. Staff to collect tea themselves if office boy unavailable.</li>
              <li>Lunch: 1:30 PM – 2:00 PM. Resume work on time.</li>
              <li>Staff to fill their own water bottles.</li>
              <li>Non-adherence treated as breach of office discipline.</li>
            </ul>
          </Section>

          {/* MOBILE POLICY */}
          <Section title="14. PERSONAL MOBILE SUBMISSION POLICY" accent="#9333ea">
            <ul className="list-disc pl-6 space-y-1">
              <li>Personal mobiles must be submitted to HR Department upon arrival.</li>
              <li>Mobile usage during office hours strictly prohibited without HR permission.</li>
              <li>Emergency calls allowed only after HR permission.</li>
              <li>Family must contact staff only on the official office number.</li>
            </ul>
          </Section>

          {/* PROMOTION */}
          <Section title="STAFF PROMOTION CIRCULAR" accent="#1e40af">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-blue-100">
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-12">SR.</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left">PARTICULAR</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-32">INCREMENT %</th>
                </tr>
              </thead>
              <tbody>
                {PROMOTION_TABLE.map(r => (
                  <tr key={r.sr}>
                    <td className="border border-stone-300 px-2 py-1.5">{r.sr}</td>
                    <td className="border border-stone-300 px-2 py-1.5">{r.particular}</td>
                    <td className="border border-stone-300 px-2 py-1.5 text-center font-bold text-white" style={{ backgroundColor: r.color }}>{r.pct}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Section>

          {/* DKW */}
          <Section title="8 YEAR DKW STAFF INCREMENT CIRCULAR" accent="#1e40af">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-blue-100">
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-16">AGE</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-20">YEAR</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-24">SALARY</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left">PARTICULAR</th>
                </tr>
              </thead>
              <tbody>
                {DKW_TABLE.map((r, i) => (
                  <tr key={i} className="hover:bg-stone-50">
                    <td className="border border-stone-300 px-2 py-1.5">{r.age}</td>
                    <td className="border border-stone-300 px-2 py-1.5">{r.year}</td>
                    <td className="border border-stone-300 px-2 py-1.5 font-bold text-emerald-700">₹{r.salary.toLocaleString()}</td>
                    <td className="border border-stone-300 px-2 py-1.5 text-[11px]">{r.particular}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Section>

          {/* HOLIDAYS */}
          <Section title="HOLIDAY LIST — UPDATED" accent="#dc2626">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-red-100">
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-12">SR.</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-28">DATE</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-28">DAY</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left w-28">HALF/FULL</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left">HOLIDAY</th>
                  <th className="border border-stone-300 px-2 py-1.5 text-left">REMARK</th>
                </tr>
              </thead>
              <tbody>
                {HOLIDAYS.map(h => (
                  <tr key={h.sr} className="hover:bg-stone-50">
                    <td className="border border-stone-300 px-2 py-1.5">{h.sr}</td>
                    <td className="border border-stone-300 px-2 py-1.5 font-mono">{h.date}</td>
                    <td className="border border-stone-300 px-2 py-1.5">{h.day}</td>
                    <td className="border border-stone-300 px-2 py-1.5">
                      <span className={`px-2 py-0.5 rounded text-[10px] font-bold text-white ${h.type === 'FULL DAY' ? 'bg-red-600' : 'bg-amber-600'}`}>{h.type}</span>
                    </td>
                    <td className="border border-stone-300 px-2 py-1.5 font-medium">{h.name}</td>
                    <td className="border border-stone-300 px-2 py-1.5 text-[11px]">{h.remark}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="mt-3 text-[11px] text-stone-500 italic">All holidays subject to business requirement. If staff presence required, compensatory off is given against the holiday.</p>
          </Section>
        </CardContent>
      </Card>
    </div>
  );
}
